import React, { useState, useEffect } from "react";
import "./CustomTop.css";
import { useLocation, NavLink } from "react-router-dom";
import {
  BiAddToQueue,
  BiMenuAltLeft,
  BiSearch,
  BiSearchAlt2,
} from "react-icons/bi";
import {
  MdOutlineNotifications,
  MdOutlinePowerSettingsNew,
  MdOutlinePassword,
  MdOutlineSettings,
  MdOutlineArrowBack,
} from "react-icons/md";
import { RiAccountCircleLine, RiDeleteBinLine } from "react-icons/ri";
import { useAuth } from "../Utils/AuthContext";
import { useNavigate } from "react-router";
import Modal from "react-bootstrap/Modal";
import { EditDp, Login, LoginModal, Signup } from "../Components/Login";
import CustomMobile from "./CustomMobile";
import { LiaUserCheckSolid } from "react-icons/lia";
import { Notifications } from "./Notifications";
import { NewPost } from "./NewPost";
import { FaCrown } from "react-icons/fa";
import { UpgradePage } from "./UpgradePage";
import { Tab, Tabs } from "react-bootstrap";
import { CraftsModal } from "./CraftsModal";
import axiosConfig from "../Service/axiosConfig";
import {
  ChangePasswordRequest,
  DeleteAccountRequest,
} from "../Components/Navbar";
import { useNotification } from "../Utils/NotificationCount";
import SearchBarComponent from "../Components/Navbar/Searchbarcomponent";
import { useSelector } from "react-redux";

const CustomTop = ({
  query,
  handleInputChangeDebounced,
  isVisible,
  setIsVisible,
}) => {
  const totalUnread = useSelector((state) => state.chat.totalUnread);

  const location = useLocation();
  const Navigate = useNavigate();
  const {
    setIsLoggedIn,
    isLoggedIn,
    setIs24Craft,
    is24Craft,
    socketUrl,
    setSocketurl,
    messagelabel,
    setMessagelabel,
  } = useAuth();
  const [show, setShow] = useState(false);
  const [loginShow, setloginShow] = useState(false);
  const [loginView, setloginView] = useState("login");
  // const handleLoginClose = () => setloginShow(false);
  const handleLoginShow = () => {
    setloginShow(true);
    setloginView("login");
  };
  const [ProfileData, setProfileData] = useState({});
  const [isRead, setIsRead] = useState(false);
  const [page, setPage] = useState(1);
  const [AddPost, setAddPost] = useState(false);
  const [DeleteAlert, setDeleteAlert] = useState("");
  const [PasswordAlert, setPasswordAlert] = useState("");
  const {
    notificationCount,
    fetchNotificationCount,
    fetchMessageCount,
    messageCount,
  } = useNotification();

  const setProfile = () => {
    setProfileData(JSON.parse(localStorage.getItem("profile_data")));
  };
  const ActiveData = (activeUrl) => {
    setIsLoggedIn(false);
    localStorage.setItem("activeurl", activeUrl);
  };
  const hcc_id = localStorage.getItem("hcc_id");
  const MobileLogin = () => {
    Navigate(`/profile/${hcc_id}`);
  };
  function handleLoginEvent() {
    // handleLoginClose();
    setIsLoggedIn(true);
    setProfile();
    if (localStorage.getItem("is_24_craft")) {
      setIs24Craft(true);
    }
  }
  const CheckLogin = async () => {
    if (localStorage.getItem("token")) {
      setIsLoggedIn(true);
      setProfile();
    }
    if (localStorage.getItem("is_24_craft")) {
      setIs24Craft(true);
    }
  };
  const handleClose = () => {
    setShow(false);
    setIsRead(false);
    fetchNotificationCount();
  };
  const [UpgradeShow, setUpgradeShow] = useState(false);
  const [ScreenVisbile, setScreenVisbile] = useState("plans");
  const HandleUpgrade = () => {
    setUpgradeShow(true);
  };
  const handleUpgradeClose = () => {
    setUpgradeShow(false);
    setScreenVisbile("plans");
  };
  // const [key, setKey] = useState('Login');
  const [profilePic, setProfilepic] = useState(false);
  const [showApply, setshowApply] = useState(false);
  let profile_data = JSON.parse(localStorage.getItem("profile_data"));
  const handleShow = () => {
    if (localStorage.getItem("token")) {
      if ((profile_data && profile_data.profile_pic === null) || "") {
        setProfilepic(true);
      } else if (localStorage.getItem("is_24_craft") === null) {
        setshowApply(true);
      } else {
        setShow(true);
        setPage(1);
      }
    } else {
      handleLoginShow();
    }
  };
  const HandleMessage = () => {
    Navigate("/messages");
    setMessagelabel(false);
  };
  const handleprofilpicclose = () => {
    setProfilepic(false);
  };
  const handleDepartmentClose = () => {
    setshowApply(false);
  };
  const getIdFromUrl = () => {
    const path = window.location.pathname;
    const segments = path.split("/");
    const id = segments[segments.length - 1];
    console.log(path, "path", typeof id);
    return id;
  };
  const MessagelabelIcon = () => {
    console.log(socketUrl, "messageSocket");
    if (socketUrl) {
      socketUrl.on("message", (data) => {
        console.log("New messages received", data);
        console.log(data.sender);
        if (JSON.stringify(data.sender) === getIdFromUrl()) {
          setMessagelabel(false);
        } else {
          setMessagelabel(true);
          fetchMessageCount();
        }
      });
      return () => {
        socketUrl.off("newMessage");
      };
    }
  };
  useEffect(() => {
    MessagelabelIcon();
  }, [socketUrl]);
  useEffect(() => {
    setProfile();
    CheckLogin();
    if (location.pathname === "/signup") {
      if (localStorage.getItem("token")) {
        Navigate("/");
        setloginView("");
        setloginShow(false);
      } else {
        console.log("test");
        setloginView("Signup");
        setloginShow(true);
      }
    }
  }, []);
  return (
    <>
      <div className="desktop-container">
        <div className="header-content">
          <div className="top-main">
            <div className="logo" onClick={() => Navigate("/")}>
              <img
                src={require("../Pages/images/newHCCLogo.png")}
                alt="logo"
                className="logo-image"
              />
            </div>
            <SearchBarComponent
              query={query}
              handleInputChangeDebounced={handleInputChangeDebounced}
            />
            {isLoggedIn ? (
              <div className="options">
                <div className="options-container">
                  <div onClick={handleShow} style={{ position: "relative" }}>
                    <img
                      src={require("./images/bell.webp")}
                      className="option-icon"
                    />
                    {notificationCount > 0 && (
                      <div className="message-label">{notificationCount}</div>
                    )}
                  </div>
                  <div onClick={HandleMessage} style={{ position: "relative" }}>
                    <img
                      src={require("../Pages/images/messageicon.webp")}
                      alt="icon"
                      className="option-icon"
                    />{" "}
                    {totalUnread > 0 && (
                      <div className="message-label">{totalUnread}</div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="options">
                <div className="login-text" onClick={handleLoginShow}>
                  login
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="top-mobile-main">
        {location.pathname === "/s" ? (
          <div className="search-bar-filter">
            <div
              className="search-mobile"
              style={{ height: "30px", alignItems: "center" }}
            >
              <MdOutlineArrowBack
                style={{ position: "absolute", left: "16px" }}
                size={20}
                onClick={() => Navigate("/")}
              />
              <input
                type="text"
                placeholder="Search for Artists..."
                value={query}
                onChange={handleInputChangeDebounced}
                autoFocus={true}
              />
              <BiSearch size={20} />
            </div>
          </div>
        ) : (
          <>
            <div className="logo">
              {isLoggedIn && (
                <div class="dropdown show-only-mobile">
                  <button
                    type="button"
                    class="btn btn-default dropdown-toggle"
                    data-bs-toggle="dropdown"
                    style={{ border: "none" }}
                  >
                    <img
                      src={require("../Components/Navbar/images/more.webp")}
                      alt="more_image"
                      style={{ height: "22px", width: "28px" }}
                    />
                  </button>
                  <ul class="dropdown-menu dropdown-margin popup-sheet">
                    <li>
                      <NavLink
                        to={`/profile/${hcc_id}`}
                        className="dropdown-item"
                      >
                        {" "}
                        <RiAccountCircleLine /> My Profile
                      </NavLink>
                    </li>
                    <li>
                      <div className="dropdown-item" onClick={HandleUpgrade}>
                        {" "}
                        <FaCrown
                          color="#daa520"
                          style={{ width: "16px", marginRight: "5px" }}
                        />
                        {JSON.parse(localStorage.getItem("is_pro"))
                          ? "Pro Member"
                          : "Upgrade"}
                      </div>
                    </li>
                    <li>
                      <NavLink to="/shortlist" className="dropdown-item">
                        {" "}
                        <LiaUserCheckSolid /> Shortlisted Profiles
                      </NavLink>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#">
                        <MdOutlineSettings /> Setting
                      </a>
                    </li>
                    <li>
                      <div
                        class="dropdown-item"
                        onClick={() => setPasswordAlert(true)}
                      >
                        <MdOutlinePassword /> Change Password
                      </div>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => setDeleteAlert("success")}
                      >
                        <RiDeleteBinLine /> Delete Account
                      </a>
                    </li>
                    <li>
                      <NavLink to="/logout" className="dropdown-item">
                        <MdOutlinePowerSettingsNew /> Log Out
                      </NavLink>
                    </li>
                    <li className="follow-us">
                      <hr />
                      <a
                        class="dropdown-item"
                        href="#"
                        style={{ textAlign: "center" }}
                      >
                        Follow Us On
                      </a>
                      <div className="social-align">
                        <img
                          src={require("../Pages/images/facebook.jpg")}
                          className="social-icons"
                        />
                        <img
                          src={require("../Pages/images/instagram.jpg")}
                          className="social-icons"
                        />
                        <img
                          src={require("../Pages/images/youtube1.jpg")}
                          className="social-icons"
                        />
                        <img
                          src={require("../Pages/images/twitter.png")}
                          className="social-icons"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              )}
              <img
                src={require("../Pages/images/newHCCLogo.png")}
                className="logo-image"
              />
              <div className="d-flex" style={{ gap: "20px " }}>
                <div onClick={handleShow} style={{ position: "relative" }}>
                  <img
                    src={require("./images/bell.webp")}
                    className="option-icon"
                  />
                  {notificationCount > 0 && (
                    <div className="message-label">{ }</div>
                  )}
                </div>
                <div onClick={HandleMessage} style={{ position: "relative" }}>
                  <img
                    src={require("../Pages/images/messageicon.webp")}
                    className="option-icon"
                  />{" "}
                  {totalUnread > 0 && (
                    <div className="message-label">{totalUnread}</div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        <CustomMobile />
      </div>
      <Notifications
        show={show}
        setShow={setShow}
        handleClose={handleClose}
        ProfileData={profile_data}
        isRead={isRead}
        setIsRead={setIsRead}
        setPage={setPage}
        page={page}
      />
      {loginShow && (
        <LoginModal
          loginShow={loginShow}
          setloginShow={setloginShow}
          setloginView={setloginView}
          loginView={loginView}
        />
      )}
      {AddPost && <NewPost AddPost={AddPost} setAddPost={setAddPost} />}
      {UpgradeShow && (
        <UpgradePage
          UpgradeShow={UpgradeShow}
          setUpgradeShow={setUpgradeShow}
          ScreenVisbile={ScreenVisbile}
          setScreenVisbile={setScreenVisbile}
          handleUpgradeClose={handleUpgradeClose}
        />
      )}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={profilePic}
        onHide={handleprofilpicclose}
        className="edit-profile-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add your profile to get started</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditDp
            handleLoginEvent={handleprofilpicclose}
            showApply={showApply}
            setshowApply={setshowApply}
          />
        </Modal.Body>
      </Modal>
      {showApply && (
        <CraftsModal
          showApply={showApply}
          setshowApply={setshowApply}
          handleClose={handleDepartmentClose}
        />
      )}
      {DeleteAlert === "success" && (
        <DeleteAccountRequest
          DeleteAlert={DeleteAlert}
          setDeleteAlert={setDeleteAlert}
        />
      )}
      {PasswordAlert && (
        <ChangePasswordRequest
          PasswordAlert={PasswordAlert}
          setPasswordAlert={setPasswordAlert}
        />
      )}
    </>
  );
};

export default CustomTop;
